import React from 'react';

export default function({ className }:{className:string[]}) {
  const classes = ['loading-spinner', className];
  return (
    <div className={classes.join(' ')}></div>
  );
}
